import type { PageTranslation } from '@portal/schema/studio/studio';
import { routes } from 'constants/routes';
import { languages } from 'schema/locale';

export const ARTICLES_BY_PAGE = 12;

export const pageTranslationsLinks: PageTranslation[] = languages.map((item) => ({
  slug: { _type: 'slug', current: routes.eduHub },
  language: item
}));
